import { render, staticRenderFns } from "./GrabForm.vue?vue&type=template&id=5126780b&scoped=true&"
import script from "./GrabForm.vue?vue&type=script&lang=ts&"
export * from "./GrabForm.vue?vue&type=script&lang=ts&"
import style0 from "./GrabForm.vue?vue&type=style&index=0&id=5126780b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5126780b",
  null
  
)

export default component.exports